import { jsx as _jsx } from "react/jsx-runtime";
import MuiBadge from '@mui/material/Badge';
import * as React from 'react';
import { makeEnum, withVersion } from '../utils';
const variants = [
    'dot',
    'standard',
    'medium'
];
export const BadgeVariant = makeEnum(...variants);
export const Badge = withVersion((props) => {
    const { sx = {} } = props;
    const variantClasses = variants.reduce((acc, variant) => ({
        ...acc,
        [`.MuiBadge-${variant}`]: ({ components }) => {
            switch (variant) {
                case 'medium':
                    return components?.badge?.[`label-${variant}`] ?? {};
                case 'dot':
                case 'standard':
                    return {};
            }
        }
    }), {});
    return (_jsx(MuiBadge, { "data-role": "badge", ...props, sx: {
            ...variantClasses,
            ...sx
        } }));
}, '1.0.0');
